"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgImage(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.213 2A1.79 1.79 0 0124 3.787v16.34a1.79 1.79 0 01-1.787 1.788H1.787A1.79 1.79 0 010 20.128V3.788A1.79 1.79 0 011.787 2zM7.874 9.936l-6.343 5.437v4.755a.26.26 0 00.198.248l.058.007h20.426a.258.258 0 00.255-.255v-1.765l-4.463-5.356-3.503 2.627a.766.766 0 01-.916.003l-.085-.074-5.627-5.627zm14.339-6.404H1.787a.258.258 0 00-.255.255l-.001 9.569 5.885-5.044a.766.766 0 01.95-.037l.09.077 5.66 5.658 3.552-2.665a.766.766 0 01.972.043l.076.08 3.752 4.501V3.787a.26.26 0 00-.197-.248l-.058-.007zM16.599 5.83a1.532 1.532 0 11-.006 3.064 1.532 1.532 0 01.006-3.064z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgImage;
exports.default = _default;